import moment from "moment";

export const ROWS_PER_PAGE = 25;

export const statusFilterOptions = [
  { value: "DELIVERED", name: "DELIVERED" },
  { value: "FAILED", name: "FAILED" },
];

export const deliveryTypeFilterOptions = [
  { value: "MFT", name: "MFT" },
  { value: "FAX", name: "FAX" },
  { value: "HL7", name: "HL7" },
];

export const LIST_COLUMNS = [
  "Timestamp",
  "Org",
  "Encounter",
  "Registry",
  "Delivery type",
  "Protocol",
  "File type",
  "Status",
  "Triggered by",
  "Error",
];

export const truncateError = (message, max = 80) => {
  if (!message) return "";
  const text = String(message);
  return text.length > max ? `${text.slice(0, max)}…` : text;
};

export const formatAuditTimestamp = (iso) => {
  if (!iso) return "—";
  const m = moment(iso);
  if (!m.isValid()) return "—";
  // e.g. AUG-05-2026 | 04:23:45 PM
  return m.format("MMM-DD-YYYY | hh:mm:ss A").toUpperCase();
};

/** Who initiated the delivery run — prefers stored display name, then id. */
export const formatTriggeredBy = (row) => {
  const displayName = row?.triggeredByName?.trim();
  if (displayName) {
    const id = row?.triggeredBy;
    return {
      label: displayName,
      title:
        displayName === "Automated"
          ? "Triggered by system (encounter pipeline)"
          : id && id !== displayName
            ? `Actor id: ${id}`
            : undefined,
    };
  }

  if (!row?.triggeredBy) return { label: "—", title: undefined };
  const value = String(row.triggeredBy).trim();
  if (!value) return { label: "—", title: undefined };
  if (value.toLowerCase() === "system") {
    return {
      label: "Automated",
      title: "Triggered by system (encounter pipeline)",
    };
  }
  return { label: value, title: `Triggered by ${value}` };
};

/**
 * Delivery status chip: DELIVERED | FAILED (open) | FAILED (resolved via resolvedAt).
 */
export const getDeliveryStatusChip = (row) => {
  if (row.status === "DELIVERED") {
    return { label: "DELIVERED", className: "rda-chip rda-chip--delivered" };
  }
  if (row.status === "FAILED") {
    if (row.resolvedAt) {
      return {
        label: "FAILED (resolved)",
        className: "rda-chip rda-chip--failed-resolved",
        title: `Resolved at ${formatAuditTimestamp(row.resolvedAt)}`,
      };
    }
    return { label: "FAILED", className: "rda-chip rda-chip--failed-open" };
  }
  return { label: row.status || "—", className: "rda-chip" };
};

/** Map API audit rows to display fields for the list table (DELIVERY rows only). */
export const mapAuditRowForTable = (row, orgNameById = {}) => {
  const rawTime = row.completedAt || row.createdAt;
  const fullError = row.errorMessage || "";
  const truncated = truncateError(fullError);
  const triggeredBy = formatTriggeredBy(row);
  return {
    ...row,
    id: row.sk || `${row.orgId}-${row.createdAt}-${row.recordType}`,
    displayTime: formatAuditTimestamp(rawTime),
    displayOrg: orgNameById[row.orgId] || row.orgId || "—",
    displayRegistry: row.registryName || row.registryId || "—",
    displayDeliveryType: row.deliveryType || "—",
    displayProtocol: row.protocol || "—",
    displayFileType: row.fileType || "—",
    displayTriggeredBy: triggeredBy.label,
    triggeredByTitle: triggeredBy.title,
    displayError: truncated || "—",
    fullError,
    errorTruncated: Boolean(fullError && truncated !== fullError),
  };
};
